<template>
    <router-link :to="getDocumentationLink(content)">
        <ListCard
            card-type="small"
            class="document-list-card-small"
            :title="content.title"
            :locale-tag="content.language"
            :test-id="testId"
            :fallback-icon="getDocumentIcon(content.type)"
        >
            <template #subtitle>
                <div class="col subtitle light-text-color qit-text-ellipsis">
                    <template v-if="$slots.subtitle">
                        <slot name="subtitle" :content="content" />
                    </template>
                    <template v-else>
                        <span :class="{ invisible: !content.rootContentMapTitle }">
                            {{ $t("documentation.in {path}", { path: content.rootContentMapTitle }) }}
                        </span>
                    </template>
                </div>
            </template>
            <template #content>
                <div v-if="content.propertyItems" class="row properties col-gap-xxl">
                    <PropertyView :items="content.propertyItems" :multiline="multiline" />
                </div>
            </template>
        </ListCard>
    </router-link>
</template>

<script setup lang="ts">
import PropertyView from "@/shared/components/views/property-view.vue";
import ListCard from "@/shared/components/card/list-card.vue";
import { getDocumentIcon } from "@/shared/documentation/icon.utils.ts";
import { Documentation } from "@/shared/documentation/documentation.types.ts";
import { useDocumentRoute } from "@/shared/router/document-route.ts";
import { SearchContext } from "@/shared/search/search.types.ts";

interface DocumentationListCardSmallProps {
    content: Documentation;
    context: SearchContext;
    testId?: string;
    multiline?: boolean;
}

const props = defineProps<DocumentationListCardSmallProps>();

const { getPathToDocumentationDetailPageForSearch } = useDocumentRoute();

const getDocumentationLink = (item: Documentation) => {
    return getPathToDocumentationDetailPageForSearch(item.contentMapId!, item.topicId, {
        context: props.context,
        products: item.products,
    });
};
</script>

<style lang="scss" scoped>
.document-list-card-small {
    max-width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-start;
}
</style>
